export default __webpack_public_path__ + "static/media/writing.2ef62f38.png";